module.exports = __webpack_public_path__ + "static/img/fg-02_21.4113eea.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo/fg-02_21.gif
// module id = R7fW
// module chunks = 1